export default __webpack_public_path__ + "static/media/safety.5f67c81f.svg";